module.exports = __webpack_public_path__ + "media/images/front/about/point1_img01-09a3e4fc4f90cb508cc1af747c1cf06c.jpg";